import axios from "axios";
import { BASE_URL } from "../config";

const getAuthHeaders = () => {
  const token =
    localStorage.getItem("authentication/token") ||
    localStorage.getItem("auth_token") ||
    localStorage.getItem("token") ||
    "";

  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const uploadMemberChangePlanBatch = (formData) =>
  axios.post(`${BASE_URL}/members/batch-change-plan/upload`, formData, {
    headers: {
      ...getAuthHeaders(),
      "Content-Type": "multipart/form-data",
    },
  });

export const getMemberChangePlanBatchUploadHistory = (params) =>
  axios.get(`${BASE_URL}/members/batch-change-plan/uploads`, {
    params,
    headers: getAuthHeaders(),
  });

export const getMemberChangePlanBatchProcessedRows = (uploadId, params) =>
  axios.get(`${BASE_URL}/members/batch-change-plan/processed/${uploadId}`, {
    params,
    headers: getAuthHeaders(),
  });

export const exportMemberChangePlanBatchProcessedRows = (uploadId, params) =>
  axios.post(
    `${BASE_URL}/members/batch-change-plan/processed-export/${uploadId}`,
    {},
    {
      params,
      headers: getAuthHeaders(),
      responseType: "blob",
    }
  );

export const refreshMemberChangePlanBatchUploadSignedUrl = (uploadId) =>
  axios.post(
    `${BASE_URL}/members/batch-change-plan/refresh-url`,
    { upload_id: uploadId },
    { headers: getAuthHeaders() }
  );
